import { UserPermission } from "@/models/userPermission";
import hasAnyOfPermissions from "@/functional/permissions/hasAnyOfPermissions";
import Role from "@/models/seededRole.model";
import type { RoleModel } from "@/models/role.model";

export default (userPermissions: string[]): boolean => {
  return hasAnyOfPermissions(userPermissions, [
    UserPermission.superAdmin,
    UserPermission.viewOrganisationUsers,
  ]);
};

export function hasHierarchicallySameOrHigherRole(
  userRoles: RoleModel[],
  comparedToRoles: RoleModel[],
): boolean {
  if (userRoles.length === 0) {
    return false;
  }

  // Used in the interim before scoped roles are introduced
  const roleHierarchy: Record<string, number> = {
    [Role.SUPER_ADMIN]: 0,
    [Role.ADMIN]: 1,
    [Role.MANAGER]: 2,
  };

  let currentUserLowestRoleVal = Infinity;
  for (const userRole of userRoles) {
    if (roleHierarchy[userRole.displayName] !== undefined) {
      currentUserLowestRoleVal = Math.min(
        currentUserLowestRoleVal,
        roleHierarchy[userRole.displayName],
      );
    }
  }
  if (currentUserLowestRoleVal === Infinity) {
    return false;
  }

  let comparedUserLowestRoleVal = Infinity;
  for (const userRole of comparedToRoles) {
    if (roleHierarchy[userRole.displayName] !== undefined) {
      comparedUserLowestRoleVal = Math.min(
        comparedUserLowestRoleVal,
        roleHierarchy[userRole.displayName],
      );
    }
  }

  return currentUserLowestRoleVal <= comparedUserLowestRoleVal;
}
